export const setBillDiscountAction = (offer, discount) => ({
    type: 'SET_BILL_DISCOUNT',
    payload: {
        offer,
        discount,
    },
})
export const clearBillDiscount = () => ({
  type: "CLEAR_BILL_DISCOUNT",
});

